import { render, staticRenderFns } from "./PostBlock.vue?vue&type=template&id=1a1d71b4&scoped=true&"
import script from "./PostBlock.vue?vue&type=script&lang=js&"
export * from "./PostBlock.vue?vue&type=script&lang=js&"
import style0 from "./PostBlock.vue?vue&type=style&index=0&id=1a1d71b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1d71b4",
  null
  
)

export default component.exports